import React, { Component } from "react";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import { TableComp } from "sz-react-utils";
import moment from "moment";
import lodash from "lodash";
import {
  Button,
  Card,
  Checkbox,
  DatePicker,
  Drawer,
  notification,
  Tooltip,
  Select,
  Row,
  Col,
  Popconfirm,
} from "antd";

import Request from "../../../request";

import { connect } from "react-redux";
import styles from "./styles.less";
import setting from "../../../components/_utils/settings";
import common from "../../common.less";
import ListFollowUps from "../../../components/_utils/listFollowUp";
import SMS from "../../../components/communication/sms";
import WhatsAPPSMS from "../../../components/communication/WhatsAppSms";
import EmailDrawer from "../../../components/communication/emailDrawer";
import S from "string";
import { RightsWrapper } from "../../../components/_utils/utils";
import VisaListFollowUps from "../../../components/_utils/visaListFollowUp";
import { hideLoader, showLoader } from "../../../modules/actions";

import rightAuth from "../../../components/_utils/userRights";
import { DatabaseFilled } from "@ant-design/icons";

let counsellingData = {};
let studentObj = {};
const Option = Select.Option;
const { RangePicker } = DatePicker;

class CollapseViewBox extends Component {
  state = {
    cp: true,
  };

  render() {
    const { cp } = this.state;

    return (
      <React.Fragment>
        <div
          className={
            cp
              ? styles.followUpDetailsCollapse
              : styles.followUpDetailsCollapseNot
          }
        >
          {this.props.children}
        </div>
        <button
          style={{ color: "red", float: "right" }}
          onClick={() => {
            this.setState({
              cp: !cp,
            });
          }}
        >
          {cp ? <p>View More + </p> : <p>View Less - </p>}
        </button>
      </React.Fragment>
    );
  }
}

class VisitorVisaFollowUps extends Component {
  state = {
    count: 0,
    showFollowUp: false,
    allCounsellor: [],
    userCheckBox: [],
    countryFilter: [],
    filterByCurrentUser: true,
    showDate: false,
    disabledRangePicker: true,
    showResults: true,
    // time: {
    //   key: "time",
    //   from: moment()
    //     .startOf("day")
    //     .subtract(1, "year")
    //     .format("YYYY-MM-DD HH:mm"),
    //   to: moment()
    //     .endOf("day")
    //     .format("YYYY-MM-DD HH:mm"),
    // },
    time: {},
    isAdmin: false,
    showSMS: false,
    showWhatsAppSms: false,
    showEmail: false,
    visiblePostponed: false,
    followUpDate: new Date(),
    isCounsellor: false,
    followUpType: "",
    followUpCounts: {},
    followUpTypeArr: [
      "Active",
      "Busy, Call Later",
      "Cold",
      "Didn't Pick up Call",
      "Not Interested",
      "Out Of town",
    ],
    ratingArr: [],
    countryArr: [],
    rating: null,
  };
  loadFollowTypeCounts = async () => {
    let response = await Request.loadUserFollowUpsCount();
    if (response) {
      this.setState({ followUpCounts: response });
    }
  };
  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      if (!params.sortField) {
        params.results = "50";
        params.count = "50";
        params.sortField = "id";
        params.sortOrder = "descend";
      }

      if (this.state && this.state.followUpType) {
        params.followUpType = this.state.followUpType;
      }

      if (this.state.countryId) {
        params.countryId = this.state.countryId;
      }
      let userCheckBox = {}
      let data = await Request.getVisitorVisaFollowUps({
        ...params,
        followUpDate: this.state && this.state.time,
      });
      // let data = await Request.loadUserFollowUps({
      //   ...params,
      //   regExFilters: ["studentName", "id"],
      //   followUpDate: this.state && this.state.time,
      // });

      lodash.each(data.data, (item) => {
        if (!userCheckBox[item._id]) {
          userCheckBox[item._id] = {
            _id: item._id,
            mobile: item.mobileNumber,
            studentName: item.applicantName,
            isChecked: false,
          };
        }
      });
      this.setState({ count: data.total });
      resolve(data);
    });
  };
  chooseRangerPicker = (date, dateString) => {
    this.setState(
      {
        time: {
          key: "time",
          from: date[0],
          to: date[1],
        },
      },
      () => {
        //console.log(this.state.time, '@@@@@@@@@@@@@@@@@@@')
      }
    );

    if (date[0] === undefined) {
      setTimeout(() => {
        this.reload();
      }, 500);
    }
  };
  openFollowUps = (record) => {
    studentObj = {
      counsellorId: record.counsellorId._id,
      name: record.applicantName,
      _id: record._id,
    };
    this.setState({ showFollowUp: true });
  };

  onRatingChoose = async (rating, id) => {
    let obj = {
      _id: id,
      counsellingDesk: {
        rating,
      },
    };
    let x = await Request.updateRating({ ...obj });
    if (x) {
      if (!x.error) {
        notification.success({
          message: "Success",
          description: x.msg,
        });
      } else {
        notification.error({
          message: "Error Saving",
          description: x.msg,
        });
      }
    }
    this.table.current.reload();
  };

  renderStatus = (val, id = "", isRating = false) => {
    if (val === "Super Hot") {
      return <div className={styles.SuperHot}>{val.toUpperCase()}</div>;
    }
    if (val === "Fit2Apply" || val === "Didn't Pick up Call") {
      return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>;
    }

    if (val === "Luke Warm" || val === "Neutral" || val === "Out Of town") {
      return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>;
    }

    if (val === "Potential" || val === "Not Interested") {
      return <div className={styles.Potential}>{val.toUpperCase()}</div>;
    }

    if (val === "Dead" || val === "Busy, Call Later") {
      return <div className={styles.dead}>{val.toUpperCase()}</div>;
    }

    if (val === "Cold" || val === "Active") {
      return <div className={styles.Cold}>{val.toUpperCase()}</div>;
    }

    if (
      isRating === true &&
      (val === "" || val === null || val === undefined)
    ) {
      return (
        <Select
          style={{ width: 90 }}
          value={this.state.rating}
          placeholder="Select Rating"
          optionFilterProp="display"
          onChange={(val) => {
            this.onRatingChoose(val, id);
          }}
        >
          {this.state.ratingArr.slice(0, -1).map((rEl, i) => {
            return (
              <Option key={i} value={rEl}>
                {rEl}
              </Option>
            );
          })}
        </Select>
      );
    }
  };
  closeWhatsSMS = () => {
    this.setState({ showWhatsAppSms: false });
  };
  closeSMS = () => {
    this.setState({ showSMS: false });
  };

  closeEmail = () => {
    this.setState({ showEmail: false });
  };

  closeFollowUp = () => {
    this.setState({ showFollowUp: false });
    this.reload();
  };
  onOk = (value) => {
    this.setState({ showResults: true }, () => {
      this.reload();
    });
  };
  reload = () => {
    this.table.current.reload();
  };

  getAllRatings = async () => {
    let response = await Request.getRatingsDetails({
      results: 1000,
      count: 1000,
    });
    this.setState({ ratingArr: response.data });
  };

  constructor(props) {
    super(props);
    this.table = React.createRef();
    this.loadCountry();
    this.getAllRatings();
    this.loadFollowTypeCounts();
  }

  selectUser = (item, studentId) => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId]
      .isChecked;
    this.setState({ userCheckBox: cloneUserCheckBox });
  };
  selectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = true;
    });
    this.setState({ userCheckBox: cloneUserCheckBox });
  };
  unselectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox);
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = false;
    });
    this.setState({ userCheckBox: cloneUserCheckBox });
  };
  showEmail = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showEmail: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };
  showWhatsAppSms = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked === true ? item : false;
    });

    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showWhatsAppSms: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };
  showSMS = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ showSMS: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };
  visiblePostponedShow = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked;
    });
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr,
      };
      this.setState({ visiblePostponed: true });
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };

  movetoDead = async (recordId) => {
    let response = await Request.moveEnquiryToDead(recordId);
    if (response.success) {
      notification.success({
        message: response.message
      })
    } else {
      notification.error({
        message: response.message
      })
    }
    this.reload()
  }

  moveToParked = async(recordId)=>{
      let response = await Request.moveEnquiryToParked({ id: recordId });
      if (response.success) {
        notification.success({
          message: response.message,
        });
      } else {
        notification.error({
          message: response.message,
        });
      }
      this.reload()
    }

  handleMoveToDeadInquiry = async () => {
    let obj = {
      ids: [],
      atLevel: "Dead Inquiry",
    };
    lodash.each(this.state.userCheckBox, (item, key) => {
      if (item.isChecked) {
        obj.ids.push(item._id);
      }
    });

    if (obj.ids.length) {
      this.setState({ loading: true });
      let resp = await Request.moveToDeadInquiry(obj);

      if (resp.success) {
        notification.success({
          message: resp.msg,
        });
        this.setState({ loading: false });
        this.reload();
      } else {
        notification.error({
          message: resp.msg,
        });
        this.setState({ loading: false });
      }
    } else {
      notification.error({
        message: "Please select atleast 1 user.",
      });
    }
  };

  componentWillMount() {
    let searchParams = new URLSearchParams(this.props.search);
    let followUpType = searchParams.get("followUpType");
    this.setState({ followUpType: followUpType });
    let followUpShow = searchParams.get("followUpShow");
    if (followUpShow === "Today") {
      let sDate = moment()
        .startOf("day")
        .format("YYYY-MM-DD HH:mm");
      let eDate = moment()
        .endOf("day")
        .format("YYYY-MM-DD HH:mm");
      this.chooseRangerPicker([sDate, eDate]);

      setTimeout(() => {
        this.onOk();
      }, 1000);
    } else if (followUpShow === "OverDue") {
      let sDate = moment()
        .subtract(31, "days")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm");
      let eDate = moment()
        .subtract(1, "days")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm");
      this.chooseRangerPicker([sDate, eDate]);

      setTimeout(() => {
        this.onOk();
      }, 1000);
    }
    if (followUpType) {
      setTimeout(() => {
        this.onOk();
      }, 1000);
    }
  }

  onCountryChoose = (countryId) => {
    this.setState({ countryId: countryId }, () => {
      this.table.current.reload();
    });
  };

  loadCountry() {
    let params = {
      results: 100,
      sortField: "countryName",
      sortOrder: "ascend",
    };
    Request.getCountriesWithoutAuth(params)
      .then((resp) => {
        if (resp) {
          let temp = [];
          let countryFilter = [];
          lodash.each(resp.data, (vv) => {
            temp.push({
              display: vv.countryName,
              id: vv._id,
            });
            countryFilter.push({
              text: vv.countryName,
              value: vv.countryName
            })
          });
          this.setState({ countryArr: temp, countryFilter: countryFilter });
        }
      })
      .catch((err) => { });
  }

  async componentDidMount() {
    let isCounsellor = true,
      isAdmin = false;

    let localUser = JSON.parse(localStorage.getItem("user"));
    if (localUser) {
      // isCounsellor = localUser.isCounsellor;
      if (localUser.userType === "Admin") {
        isAdmin = true;
      }
    }

    let visitorParams = {
      sortField: '_id',
      sortOrder: 'ascend',
      results: 200,
      active: true,
      userType: { $ne: "Student" },
      userBranch: localUser.userBranch,
      isVisitorVisaCounsellor: true
    }

    let response = await Request.loadUser({ ...visitorParams, regExFilters: ['name'] });

    this.setState({
      allCounsellor: response.data,
      loading: false,
      isCounsellor,
      isAdmin,
    });
  }

  async postponedFxn() {
    if (!this.state.followUpDate) {
      notification.error({
        message: "Please choose FollowUp Date.",
      });
      return;
    }
    let obj = {
      ids: [],
      followUpDate: moment(this.state.followUpDate),
    };
    lodash.each(this.state.userCheckBox, (item, key) => {
      if (item.isChecked) {
        obj.ids.push(item._id);
      }
    });
    this.setState({ loading: true });

    let resp = await Request.postponedFollowups(obj);
    if (resp.success) {
      notification.success({
        message: resp.msg,
      });
      this.setState({ visiblePostponed: false, loading: false });
      this.reload();
    } else {
      notification.error({
        message: resp.msg,
      });
      this.setState({ loading: false });
    }
  }

  render() {
    const { dispatch } = this.props;
    const {
      allCounsellor,
      userCheckBox,
      followUpTypeArr,
      ratingArr,
      followUpCounts,
    } = this.state;

    const columns = [
      {
        title: "Action",
        key: "operation",
        float: "right",
        fixed: "left",
        width: 130,
        render: (text, record) => (
          <React.Fragment>
            {/* <span className={styles.userSelectCheckbox}>
              <Checkbox
                checked={
                  userCheckBox[record._id]
                    ? userCheckBox[record._id].isChecked
                    : false
                }
                onChange={(y) => {
                  this.selectUser(y, record._id);
                }}
              />
            </span> */}

            <Tooltip title="View more followups">
              <Button
                className={styles.btn}
                shape="circle"
                size="small"
                onClick={() => this.openFollowUps(record)}
                icon="eye"
              />
            </Tooltip>
            <Tooltip title="Move to Dead Inquiry">
              <Popconfirm
                title="Are you sure to Dead this Lead?"
                onConfirm={() => {
                  this.movetoDead({ id: record._id });
                }}
                onCancel={() => {
                  console.log()
                }}
                okText="Yes"
                cancelText="No">
                <Button
                  className={styles.btn}
                  shape="circle"
                  size="small"
                  icon="forward"
                />
              </Popconfirm>
            </Tooltip>
            <Tooltip title="Move To Parked Enquiry">
              <Popconfirm
                title="Are you sure?"
                onConfirm={() => this.moveToParked(record._id)}
              >
                <Button
                  className={styles.btn}
                  size={"small"}
                  shape="circle"
                  icon="car"
                />
              </Popconfirm>
            </Tooltip>
          </React.Fragment>
        ),
      },
      {
        title: "Vision Id",
        key: "id",
        dataIndex: "id",
        searchTextName: "id",
        width: 100,
      },
      {
        title: "Applicant Name",
        key: "applicantName",
        dataIndex: "applicantName",
        searchTextName: "applicantName",
        filterRegex: true,
        width: 140,
        render: (val, record) => {
          return (
            <div>
              {val}
              <div className={styles.parentGuardianName}>
                {record.parentGuardianName
                  ? "Parent/Guardian Name: " + record.parentGuardianName
                  : ""}
              </div>
            </div>
          );
        },
      },
      {
        title: "Mobile",
        key: "mobileNumber",
        dataIndex: "mobileNumber",
        searchTextName: "mobileNumber",
        filterRegex: true,
        width: 110,
        render: (val, record) => {
          return (
            <div>
              {" "}
              {val &&
                val.length >= 10 &&
                rightAuth.checkRights("ShowClickToCall.view") ? (
                <Tooltip title="Start Call">
                  <Button
                    className="ant-btn ant-btn-primary"
                    onClick={(e) => {
                      dispatch(showLoader());
                      Request.callInitiate({
                        mobile: val,
                      }).then(({ data, error, message }) => {
                        dispatch(hideLoader());
                        if (!error) {
                          notification.success({
                            message: message,
                          });
                        } else {
                          notification.error({
                            message: message,
                          });
                        }
                      });
                    }}
                  >
                    Click To Call
                  </Button>
                </Tooltip>
              ) : (
                val
              )}
            </div>
          );
        },
      },
      // {
      //   title: "Whatsapp",
      //   key: "watsupp",
      //   dataIndex: "watsupp",
      //   searchTextName: "watsupp",
      //   filterRegex: true,
      //   width: 120,
      //   render: (val, record) => {
      //     let studentMobile = record.watsupp ? record.watsupp : record.mobile;
      //     return (
      //       <div>
      //         {" "}
      //         {studentMobile && studentMobile.length === 10 ? (
      //           <Tooltip title="Send Whatsapp Message">
      //             <a
      //               target={"_blank"}
      //               className="ant-btn ant-btn-primary"
      //               href={`whatsapp://send?text=Hi&phone=91${studentMobile}`}
      //             >
      //               Click To Send
      //             </a>
      //           </Tooltip>
      //         ) : (
      //           studentMobile
      //         )}
      //       </div>
      //     );
      //   },
      // },
      // {
      //   title: "Email",
      //   key: "emailId",
      //   dataIndex: "emailId",
      //   searchTextName: "emailId",
      //   filterRegex: true,
      //   width: 130,
      // },
      {
        title: "Counsellor",
        key: "cName",
        width: 120,
        dataIndex: "cName",
        filters:
          allCounsellor &&
          allCounsellor.map((x) => ({ value: x._id, text: x.name })),
        render: (text, record) => {
          return (
            <div>{record.counsellorId ? record.counsellorId.name : ""}</div>
          );
        },
      },

      // {
      //   title: "Desk",
      //   key: "atLevel",
      //   dataIndex: "atLevel",
      //   width: 100,
      //   filters: [
      //     { text: `${setting.deskNameObj["Front Desk"]}`, value: "Front Desk" },
      //     { text: "Registration Desk", value: "Registration Desk" },
      //     { text: "Application Desk", value: "Application Desk" },
      //     { text: "Visa Desk", value: "Visa Desk" },
      //     { text: "Claim Desk", value: "Claim Desk" },
      //   ],
      //   render: (trdd, record) => {
      //     return <div>{setting.deskNameObj[trdd]}</div>;
      //   },
      // },

      // {
      //   title: "Last Follow Date",
      //   key: "entryDate",
      //   dataIndex: "entryDate",
      //   width: 100,
      //   searchDateName: "entryDate",
      //   render: (val, record) => {
      //     return (
      //       <div>
      //         {record.entryDate
      //           ? moment(record.entryDate).format("DD-MMM-YYYY")
      //           : ""}
      //       </div>
      //     );
      //   },
      // },

      {
        title: "Next Follow Up Date",
        key: "followUpDate",
        width: 100,
        render: (trdd, record) => {
          return <div>{record.followUpDate}</div>;
        },
      },
      {
        title:'Last FollowUp By',
        key:'lastFollowUpBy',
        dataIndex:'followUp.createdByUser.name',
        width:120,
        filters:
          allCounsellor &&
          allCounsellor.map((x) => ({ value: x._id, text: x.name })),
      },
      {
        title: "Details",
        key: "detail",
        width: 150,
        dataIndex: "detail",
        searchTextName: "detail",
        render: (text, record) => {
          let u = record && record.followUp && record.followUp.details ? record.followUp.details : null;
          if (u && u.length <= 100) {
            return <div>{u ? S(u).s : "N/A"}</div>;
          } else {
            return <CollapseViewBox>{u ? S(u).s : "N/A"}</CollapseViewBox>;
          }
        },
      },
      // {
      //   title: "Preference",
      //   key: "country",
      //   dataIndex:'country',
      //   width: 150,
      //   filters:this.state.countryFilter,
      //   render: (val, row) => {
      //     return row.country ? (
      //       <ul className={common.ul}>
      //         {row.country.map((val, inde) => {
      //           return <li key={inde}>{val ? val.country : ""}</li>;
      //         })}
      //       </ul>
      //     ) : null;
      //   },
      // },
      // {
      //   title: "Language",
      //   key: "language",
      //   width: 150,
      //   dataIndex: "language",
      //   render: (text, record) => {
      //     let u = record && record.profile;
      //     if (u.listening) {
      //       let ieltsDetails = [];
      //       if (u.listening) {
      //         ieltsDetails.push("L " + u.listening);
      //       }
      //       if (u.reading) {
      //         ieltsDetails.push("R " + u.reading);
      //       }
      //       if (u.speaking) {
      //         ieltsDetails.push("S " + u.speaking);
      //       }
      //       if (u.writing) {
      //         ieltsDetails.push("W " + u.writing);
      //       }
      //       if (u.overAllScore) {
      //         ieltsDetails.push("O " + u.overAllScore);
      //       }
      //       return <>{ieltsDetails.join(", ")}</>;
      //     } else {
      //       return "";
      //     }
      //   },
      // },
      // {
      //   title: "Qualification",
      //   key: "qualification",
      //   width: 250,
      //   dataIndex: "qualification",
      //   render: (text, record) => {
      //     if (record && record.profile && record.profile.newQualification) {
      //       let qualifications =
      //         record && record.profile && record.profile.newQualification;
      //       if (qualifications.length > 0) {
      //         var qualificationsHtml = [];
      //         qualifications.forEach((qualification) => {
      //           if (qualification) {
      //             let qualificationArray = [];
      //             if (qualification.qualification) {
      //               qualificationArray.push(qualification.qualification);
      //             }
      //             if (qualification.passingYear) {
      //               qualificationArray.push(qualification.passingYear);
      //             }
      //             if (qualification.percentage) {
      //               qualificationArray.push(qualification.percentage + "%");
      //             }
      //             if (
      //               qualification.stream &&
      //               Array.isArray(qualification.stream)
      //             ) {
      //               qualificationArray.push(qualification.stream.join(" | "));
      //             } else {
      //               qualificationArray.push(qualification.stream);
      //             }
      //             if (
      //               qualification.major &&
      //               Array.isArray(qualification.major)
      //             ) {
      //               qualificationArray.push(qualification.major.join(" | "));
      //             } else {
      //               qualificationArray.push(qualification.major);
      //             }
      //             if (qualification.backlogs) {
      //               qualificationArray.push(
      //                 qualification.backlogs + "Backlogs"
      //               );
      //             }
      //             if (qualification.degreeType) {
      //               qualificationArray.push(qualification.degreeType);
      //             }
      //             let qualificationHtml = (
      //               <div>
      //                 {qualificationArray.join(", ")}
      //                 <br />
      //                 <br />
      //               </div>
      //             );
      //             qualificationsHtml.push(qualificationHtml);
      //           }
      //         });
      //         return qualificationsHtml;
      //       } else {
      //         return "";
      //       }
      //     }
      //   },
      // },
      {
        title: "Branch",
        key: "studentBranchId",
        width: 100,
        render: (text, record) => {
          return (
            <div>
              {record && record.branchId ? record.branchId.branchName : ""}
            </div>
          );
        },
      },
      // {
      //   title: "Rating",
      //   key: "rating",
      //   width: 170,
      //   dataIndex: "rating",
      //   filters:
      //     ratingArr &&
      //     ratingArr.map((x) => ({ value: x._id, text: x.ratingName })),
      //   render: (val, record) => {
      //     let ratingObject =
      //       record.counsellingDesk && record.counsellingDesk.ratingObject
      //         ? record.counsellingDesk.ratingObject
      //         : null;
      //     let subRatingObject =
      //       record.counsellingDesk && record.counsellingDesk.subRatingObject
      //         ? record.counsellingDesk.subRatingObject
      //         : null;
      //     return (
      //       <div>
      //         {ratingObject ? (
      //           <div
      //             className="antd-pro-containers-desk-counselling-all-styles-rating"
      //             style={{
      //               background: ratingObject.ratingColor,
      //               borderColor: ratingObject.ratingColor,
      //             }}
      //           >
      //             {ratingObject.ratingName}{" "}
      //             {subRatingObject && subRatingObject.ratingName
      //               ? "/ " + subRatingObject.ratingName
      //               : ""}
      //           </div>
      //         ) : null}
      //       </div>
      //     );
      //   },
      // },
      {
        title: "FollowUp Type",
        key: "followUpType",
        width: 100,
        dataIndex: "followUpType",
        filters:
          followUpTypeArr &&
          followUpTypeArr.map((x) => ({ value: x, text: x })),
        render: (val, record) => {
          return this.renderStatus(val);
        },
      },
      {
        title: "Added By",
        key: "createdByUser",
        dataIndex: "createdByUser.name",
        searchTextName: "createdByUser.name",
        width: 100,
        filterRegex: true,
        render: (text, record) => {
          return (
            <div>
              <div className={common.user}>{record.createdByUser.name}</div>
              <small>{moment(record.createdByUser.time).format("DD-MM-YYYY HH:MM A")}</small>
            </div>
          );
        },
      },
    ];
    return (
      <PageHeaderWrapper title={` FollowUps : ${this.state.count} `}>
        {this.state.showFollowUp ?
          <VisaListFollowUps studentObj={studentObj} onClose={this.closeFollowUp} />
          : null}


        {this.state.showSMS ? (
          <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
        ) : null}

        {this.state.showWhatsAppSms ? (
          <WhatsAPPSMS
            counsellingData={counsellingData}
            onClose={this.closeWhatsSMS}
          />
        ) : null}

        {this.state.showEmail ? (
          <EmailDrawer
            counsellingData={counsellingData}
            onClose={this.closeEmail}
          />
        ) : null}

        {this.state.visiblePostponed && (
          <Drawer
            title=""
            placement="right"
            closable={true}
            onClose={() => {
              this.setState({ visiblePostponed: false });
            }}
            visible={this.state.visiblePostponed}
            width={1000}
          >
            <div>
              <h2
                style={{
                  marginLeft: "11px",
                  marginTop: "13px",
                  color: "orange",
                }}
              >
                Postpone Follow ups
              </h2>

              <Card>
                <p
                  style={{
                    padding: "10px",
                    textAlign: "justify",
                    marginLeft: "4px",
                    marginRight: "50px",
                  }}
                >
                  <div>
                    <h4 className="search_title" style={{ paddingTop: 8 }}>
                      Choose Followup Date
                    </h4>
                    <DatePicker
                      defaultValue={
                        this.state.followUpDate &&
                        moment(this.state.followUpDate, "YYYY-MM-DD")
                      }
                      onChange={(dueDate) => {
                        this.setState({
                          followUpDate:
                            dueDate && moment(dueDate).format("YYYY-MM-DD"),
                        });
                      }}
                    />
                    <Button
                      type="primary"
                      htmlType="submit"
                      onClick={() => this.postponedFxn()}
                      style={{ marginBottom: 10, marginLeft: "33%" }}
                      loading={this.state.loading}
                    >
                      UPDATE
                    </Button>
                  </div>
                </p>
              </Card>
            </div>
          </Drawer>
        )}

        <Card style={{ marginBottom: "10px" }}>
          <Row>
            <Col span={24} style={{ marginBottom: "30px" }}>
              <Button
                type="info"
                style={{ backgroundColor: "blue", color: "white" }}
                className={styles.btn1}
                onClick={() => {
                  this.setState({ disabledRangePicker: true });
                  this.setState({ showDate: false });
                  this.onOk();
                }}
              >
                Totals ({followUpCounts.totalFollowups})
              </Button>
              <Button
                className={styles.btn1}
                type="primary"
                onClick={() => {
                  let sDate = moment()
                    .startOf("day")
                    .format("YYYY-MM-DD HH:mm");
                  let eDate = moment()
                    .endOf("day")
                    .format("YYYY-MM-DD HH:mm");

                  this.setState({ disabledRangePicker: true });
                  this.setState({ showDate: false }, () => {
                    this.chooseRangerPicker([sDate, eDate]);
                    setTimeout(() => {
                      this.onOk();
                    }, 500);
                  });
                }}
              >
                Today's FollowUp ({followUpCounts.todaysTotals})
              </Button>
              <Button
                className={styles.btn1}
                type="primary"
                onClick={() => {
                  let sDate = moment()
                    .subtract(7, "days")
                    .startOf("day")
                    .format("YYYY-MM-DD HH:mm");
                  let eDate = moment()
                    .endOf("day")
                    .format("YYYY-MM-DD HH:mm");

                  this.setState({ disabledRangePicker: true });
                  this.setState({ showDate: false }, () => {
                    this.chooseRangerPicker([sDate, eDate]);
                    setTimeout(() => {
                      this.onOk();
                    }, 500);
                  });
                }}
              >
                Last Week ({followUpCounts.lastSevenDaysTotals})
              </Button>
              <Button
                className={styles.btn1}
                type="primary"
                onClick={() => {
                  let sDate = moment()
                    .startOf("day")
                    .subtract(15, "days")
                    .format("YYYY-MM-DD HH:mm");
                  let eDate = moment()
                    .endOf("day")
                    .format("YYYY-MM-DD HH:mm");

                  this.setState({ disabledRangePicker: true });
                  this.setState({ showDate: false }, () => {
                    this.chooseRangerPicker([sDate, eDate]);
                    setTimeout(() => {
                      this.onOk();
                    }, 500);
                  });
                }}
              >
                Last 15 Days ({followUpCounts.lastFiftenDaysTotals})
              </Button>
              <Button
                className={styles.btn1}
                type="primary"
                onClick={() => {
                  let sDate = moment()
                    .subtract(30, "days")
                    .startOf("day")
                    .format("YYYY-MM-DD HH:mm");
                  let eDate = moment()
                    .endOf("day")
                    .format("YYYY-MM-DD HH:mm");

                  this.setState({ disabledRangePicker: true });
                  this.setState({ showDate: false }, () => {
                    this.chooseRangerPicker([sDate, eDate]);
                    setTimeout(() => {
                      this.onOk();
                    }, 500);
                  });
                }}
              >
                Last Month ({followUpCounts.lastTharteenDaysTotals})
              </Button>
              <Button
                className={styles.btn1}
                type="primary"
                onClick={() => {
                  this.setState({ disabledRangePicker: false });
                }}
              >
                Custom Date Range
              </Button>
            </Col>
            <Col span={17}>
              <h4>FILTER BY DATE(Next Follow Up)</h4>
              <RangePicker
                disabled={this.state.disabledRangePicker}
                key={this.state.showDate ? "78" : "326"}
                showTime={{ format: "HH:mm" }}
                defaultValue={
                  this.state.showDate
                    ? [moment(this.state.time.from), moment(this.state.time.to)]
                    : []
                }
                format="YYYY-MM-DD HH:mm"
                placeholder={["Start Time", "End Time"]}
                onChange={this.chooseRangerPicker}
                onOk={this.onOk}
              />
            </Col>
            <Col span={7}>
              <h4>SEARCH BY COUNTRY</h4>
              <Select
                allowClear
                mode="tags"
                style={{ width: 300 }}
                showSearch={true}
                value={this.state.countryId}
                placeholder="Select Country"
                optionFilterProp="display"
                onChange={this.onCountryChoose}
                filterOption={(input, option) => {
                  return (
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
              >
                {this.state.countryArr &&
                  this.state.countryArr.map((val, idn) => {
                    return (
                      <Option key={idn} value={val.id}>
                        {val.display}
                      </Option>
                    );
                  })}
              </Select>
            </Col>
          </Row>
        </Card>
        {/* {this.state.showResults ? (
          <Card style={{ marginBottom: 10 }}>
            <Row>
              <Col span={9} />
              <Col span={4}>
                <h4>&nbsp;</h4>
                <Button
                  hidden={!this.state.isAdmin}
                  className={styles.btn1}
                  type="primary"
                  onClick={() => {
                    this.setState({
                      filterByCurrentUser: this.state.filterByCurrentUser,
                    });
                    this.onOk();
                  }}
                >
                  {" "}
                  {this.state.filterByCurrentUser
                    ? "All Users Followups"
                    : "My Followups"}
                </Button>
              </Col>
              <Col span={4}>
                <h4>&nbsp;</h4>
                <RightsWrapper myRight={"followupsDeadInquiryMove.view"}>
                  <Button
                    className={styles.btn1}
                    type="primary"
                    onClick={() => this.handleMoveToDeadInquiry()}
                  >
                    Move Dead Inquiry
                  </Button>
                </RightsWrapper>
              </Col>
              <Col span={7}>
                <h4>SEARCH BY COUNTRY</h4>
                <Select
                  allowClear
                  mode="tags"
                  style={{ width: 300 }}
                  showSearch={true}
                  value={this.state.countryId}
                  placeholder="Select Country"
                  optionFilterProp="display"
                  onChange={this.onCountryChoose}
                  filterOption={(input, option) => {
                    return (
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                >
                  {this.state.countryArr &&
                    this.state.countryArr.map((val, idn) => {
                      return (
                        <Option key={idn} value={val.id}>
                          {val.display}
                        </Option>
                      );
                    })}
                </Select>
              </Col>
            </Row>
          </Card>
        ) : null} */}

        {/* {this.state.showResults && this.state.isCounsellor ? (
          <React.Fragment>
            <Card style={{ marginBottom: 10 }}>
              <div className={styles.filterBlock}>
                <div className={styles.myBtnGroup}>
                  <Button
                    className={styles.btn}
                    type="primary"
                    onClick={() => this.showEmail()}
                  >
                    Send E-mail
                  </Button>
                  <Button
                    type="primary"
                    className={styles.btn}
                    onClick={() => this.showSMS()}
                  >
                    Send SMS
                  </Button>

                  <Button
                    type="primary"
                    className={styles.btn}
                    onClick={() => this.showWhatsAppSms()}
                  >
                    Whatsapp
                  </Button>

                  <Button
                    className={styles.btn}
                    onClick={() => this.selectAllUserFxn()}
                  >
                    Select Visible
                  </Button>
                  <Button
                    className={styles.btn}
                    onClick={() => this.unselectAllUserFxn()}
                  >
                    Unselect Visible
                  </Button>

                  <Button
                    className={styles.btn}
                    onClick={() => this.visiblePostponedShow()}
                  >
                    Postpone Follow Ups
                  </Button>
                </div>
              </div>
            </Card>
          </React.Fragment>
        ) : null} */}

        {this.state.showResults ? (
          <Card bordered={true}>
            <TableComp
              columns={columns}
              ref={this.table}
              apiRequest={this.apiRequest}
              extraProps={{ scroll: { x: 1000 } }}
              pagination={{
                showSizeChanger: true,
                defaultPageSize: "50",
                pageSizeOptions: ["10", "20", "50", "100", "1000"],
              }}
            />
          </Card>
        ) : null}
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  categories: global.categories,
  search: router.location.search,
  currentUser: global.currentUser,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VisitorVisaFollowUps);
